import { Inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { CountrySetDefaultCommand, CountrySetDefaultCommandHandlerBase, CountrySetDefaultResponse } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

@CommandHandlerFor(CountrySetDefaultCommand)
@Injectable({ providedIn: 'root'})
export class CountrySetDefaultCommandHandler {
    private commandHandler: CountrySetDefaultCommandHandlerBase;
    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new CountrySetDefaultCommandHandlerBase(http);
    }

    public async handleAsync(cmd: CountrySetDefaultCommand): Promise<CountrySetDefaultResponse> {
        return await this.commandHandler.handleAsync(cmd);
    }
}
